module.exports = __webpack_public_path__ + "img/Image_11.ddc4100d.png";